import React from 'react'

import NoPermissionContainer from '../../../../components/molecules/NoPermissionContainer'
import SettingsSection from '../../SettingsSection'
import ExistingRolesSection from './ExistingRolesSection'
import Button from '../../../../components/atoms/Button2'

import { PERMS, PORTAL_PERMS } from '@SonarCX/hooks/useAccess'
import { useRolesPermissions } from '../../../../providers/RolesPermissionsProvider'
import useStyles from './styles'

const Roles = () => {
  const { fetchPermissions, fetchRoles, state, setOpenModal, error, setData } =
    useRolesPermissions()

  const classes = useStyles()

  React.useEffect(() => {
    // only load permissions in system once
    if (!state.permissionsLoaded && !state.rolesLoaded) {
      fetchPermissions()
      fetchRoles()
    }
  }, [fetchPermissions, fetchRoles, state.permissionsLoaded, state.rolesLoaded])

  const openNormalModal = React.useCallback(() => {
    setData({
      name: '',
      details: '',
      permissions: [PERMS.AppWorkspace],
      system: false
    })
    setOpenModal(true)
  }, [setData, setOpenModal])

  const openPortalModal = React.useCallback(() => {
    setData({
      name: '',
      details: '',
      permissions: PORTAL_PERMS,
      system: false
    })
    setOpenModal(true)
  }, [setData, setOpenModal])

  return (
    <NoPermissionContainer skipAgentPage error={error}>
      <SettingsSection title='Edit Roles' loaded={true}>
        <ExistingRolesSection />

        <div className={classes.buttons}>
          <Button className={classes.button} onClick={openNormalModal}>
            CREATE AGENT ROLE
          </Button>

          <Button className={classes.button} onClick={openPortalModal}>
            CREATE PORTAL ROLE
          </Button>
        </div>
      </SettingsSection>
    </NoPermissionContainer>
  )
}

export default Roles
